<template>
  <div class="journey-grid">
    <article
      v-for="journey in journeys"
      :key="journey.name"
      class="journey-card"
      :class="{ 'journey-card--hidden': journey.isHidden }"
    >
      <p class="journey-context">{{ journey.context }}</p>
      <h3>{{ journey.name }}</h3>
      <dl>
        <div>
          <dt>Ability unlocked</dt>
          <dd>{{ journey.ability }}</dd>
        </div>
        <div>
          <dt>Merit badges</dt>
          <dd>{{ journey.meritBadges.join(' · ') }}</dd>
        </div>
      </dl>
      <router-link
        v-if="journey.to"
        :to="journey.to"
        class="journey-link"
      >
        Explore the journey
        <v-icon small aria-hidden="true">mdi-arrow-right</v-icon>
      </router-link>
      <span v-else class="journey-coming-soon">Journey page coming soon</span>
    </article>
  </div>
</template>

<script>
export default {
  name: 'HeroJourneyGrid',
  props: {
    journeys: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.journey-grid {
  display: grid;
  gap: 18px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.journey-card {
  background: rgba(8, 16, 24, 0.88);
  border: 1px solid rgba(151, 224, 255, 0.16);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  padding: 26px;
}

.journey-card--hidden {
  display: none;
}

.journey-context {
  color: #7edcff;
  font-size: 0.75rem;
  font-weight: 900;
  letter-spacing: 0.12em;
  margin-bottom: 8px;
  text-transform: uppercase;
}

.journey-card h3 {
  color: #fff;
  font-size: 1.35rem;
  letter-spacing: 0;
  margin: 0 0 20px;
}

.journey-card dl {
  margin: 0 0 24px;
}

.journey-card dl div + div {
  margin-top: 14px;
}

.journey-card dt {
  color: #8295a3;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.journey-card dd {
  color: #d9e4ea;
  line-height: 1.5;
  margin: 4px 0 0;
}

.journey-link,
.journey-coming-soon {
  align-items: center;
  display: inline-flex;
  font-size: 0.82rem;
  font-weight: 900;
  gap: 6px;
  margin-top: auto;
  text-transform: uppercase;
}

.journey-link {
  color: #8adfff;
  text-decoration: none;
}

.journey-link:focus-visible {
  border-radius: 3px;
  outline: 3px solid #fff;
  outline-offset: 4px;
}

.journey-link .v-icon {
  color: inherit;
}

.journey-coming-soon {
  color: #74828c;
}

@media (max-width: 720px) {
  .journey-grid {
    grid-template-columns: 1fr;
  }
}
</style>
